import React, { useEffect } from 'react';
import {
  ApplicationSettings,
  initializeTracking,
  trackUser,
} from '@sparknz/tracking';

interface TrackingProviderProps {
  applicationSettings: ApplicationSettings;
}

let isTrackingInitialized = false;

export default function TrackingProvider({
  children,
  applicationSettings,
}: React.PropsWithChildren<TrackingProviderProps>) {
  if (applicationSettings?.desl?.baseUrl && !isTrackingInitialized) {
    initializeTracking(applicationSettings);
    isTrackingInitialized = true;
  }

  useEffect(() => {
    trackUser();
  }, []);

  return <>{children}</>;
}
